import styled from 'styled-components';
import { ReactComponent as RawDropdownSVG } from '../../../../assets/icons/dropdown.svg';

export const IconDropdown = styled(RawDropdownSVG)``;
